import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import './style.scss'

export default class DateCell extends Component {
    static propTypes = {
        date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }

    render() {
        const { date } = this.props

        return <div className={'group-table-date-cell'}>{date ? moment(date).format('D. M. YYYY') : null}</div>
    }
}
